import { render, staticRenderFns } from "./VideoModule.vue?vue&type=template&id=2dd13b85&scoped=true"
import script from "./VideoModule.vue?vue&type=script&lang=js"
export * from "./VideoModule.vue?vue&type=script&lang=js"
import style0 from "./VideoModule.vue?vue&type=style&index=0&id=2dd13b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd13b85",
  null
  
)

export default component.exports